<template>
    <div class="select-list">
        <div class="header">
            <p :style="fontStyle" class="title">{{title}}</p>
            <p class="select-option"  :style="selectStyle" v-on:click="selectAccount">
                <span class="msg">{{model}}</span>
                <span class="icon"><img :class="!showOptions ? '' : 'reverse'" :src="downIcon" /></span>
            </p>
        </div>
        <transition name="slide-fade">
            <div class="list" v-if="showOptions" :style="listStyle" v-on:mouseleave="selectAccount">
                <p class="list-item" :class="index == currentIndex ? 'active': ''" v-for="(item, index) in options" v-on:click="changeSelect(item, index)" :style="listItemStyle">{{item.key}}</p>
            </div>
        </transition>
    </div>

</template>
<script>
import downIcon from '../../../static/img/ucenter/triangle.png'
import upIcon from '../../../static/img/ucenter/triangle_up.png'
export default {
    data: function() {
        return {
            showOptions: false,
            downIcon: downIcon,
            // currentIndex: 0,
            upIcon: upIcon
        }
    },
    props:{
        currentIndex:{
            type: Number,
            default: 0
        },
        model: {
            type: String,
            default:''
        },
        title:{
            type: String,
            default: ''
        },
        options:{
            type: Array,
            default:[]
        },
        selectStyle:{
            type: Object,
            default: {
                'width': '122px',
                'height': '34px',
                'line-height': '34px',
                'font-size': '14px',
                'color': 'rgba(51,51,51,0.90)'
            }
        },
        fontStyle:{
            type: Object,
            default:{
                'color': 'rgba(51,51,51,0.90)',
                'font-size': '14px',
                'padding-right': '8px'
            }
        },
        listStyle:{
            type: Object,
            default:{
                'width': '122px',
                'top': '34px'
            }
        },
        listItemStyle:{
            type: Object,
            default:{
                'height': '34px',
                'line-height': '34px'
            }
        }
    },
    created: function() {

    },
    methods:{
        changeSelect: function(item, index){
            this.currentIndex = index;
            this.$emit('change-select', item);
            this.showOptions = !this.showOptions;
        },
        selectAccount: function(){
            this.showOptions = !this.showOptions;

        }
    }
}
</script>
<style lang="scss" scoped>
    .select-list{
        position: relative;
        .header{
            .title{
                float: left;
                margin-top: 8px;
            }
            .select-option{
                float: left;
                border: 1px solid #dadada;
                border-radius: 4px;
                padding-left: 8px;
                .msg{
                    float: left;
                }
                .icon {
                    float: right;
                    width: 10px;
                    height: 8px;
                    margin-right: 8px;
                    &.up{
                        width: 10px;
                        height: 14px;
                    }
                    img {
                        transition: all 0.5s ease 0s;
                        &.reverse {
                            transform: rotate(180deg);
                        }
                    }

                }
            }
        }
        .list{
            position: absolute;
            right: 0px;
            float: right;
            margin-top: 10px;
            background-color: #fff;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,0.08);
            border: 1px solid #dadada;
            border-radius: 4px;
            z-index: 100;
            .list-item{
                position: relative;
                color: rgba(51,51,51,0.90);
                font-size: 14px;
                padding-left: 8px;
                cursor: pointer;
                &:hover{
                    font-weight: 600;
                    color: #364983;
                    background-color: #f4f4f4;
                }
                &.active{
                    font-weight: 600;
                    color: #364983;
                    background-color: #f4f4f4;
                }
            }
        }
        .slide-fade-enter-active {
            transition: all .3s ease;
        }
        .slide-fade-leave-active {
            transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .slide-fade-enter, .slide-fade-leave-to {
            transform: translateY(-10px);
            opacity: 0;
        }


    }
</style>



// WEBPACK FOOTER //
// src/components/common/select/select.vue